import { useTheme } from '@mui/material/styles';
import {useState} from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';

import useMediaQuery from '@mui/material/useMediaQuery';

//social icons
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import LanguageIcon from '@mui/icons-material/Language';

function Footer() {

  const theme = useTheme();

  const mobile = useMediaQuery('(max-width:1000px)');

  function MenuButton({ children, ...props }) {
    return (
      <Typography m={mobile ? 0 : 1} variant="h6" component="div" sx={{ flexGrow: props.flexGrow }}>
        <Button style={{ color: theme.palette.quinary.main, fontSize: mobile ? "18px" : "22px" }}>{children}</Button>
      </Typography>
    )
  }
    
  function SocialIcon({ children, ...props }) {
    return (
      <Typography m={mobile ? 0 : 1} variant="h6" component="div" sx={{ flexGrow: props.flexGrow }}>
        {children}
      </Typography>
    )
  }

  function MenuButtons() {
    return (
      <>
        <Typography textAlign="center" p={2} variant="h3"color={theme.palette.quinary.main} component="div">For Inquiry: 94matteo1@gmail.com </Typography>
        {mobile ? <></> : <MenuButton flexGrow={0.5}></MenuButton>}
      </>
    )
  }

  function SocialButtons() {
    

    function SocialCard({children, ...props}){
      const [hovered, setHover] = useState(false)
      return(
        <Card
          onPointerOver={() => setHover(true)}
          onPointerLeave={() => setHover(false)}
          sx={{
            backgroundColor:"rgba(1,1,1,0)",
          }}
          style={{
            cursor:hovered ? 'pointer' : 'auto',
            opacity:hovered?"0.5":"1"
          }}
        >
          <SocialIcon flexGrow={0}>{children}</SocialIcon>
        </Card>
      )
    }

    return (
      <>
        <SocialCard><FacebookIcon  color={"quinary"} fontSize="large"></FacebookIcon> </SocialCard>
        <SocialCard><LinkedInIcon color={"quinary"} fontSize="large"></LinkedInIcon></SocialCard>
        <SocialCard><LanguageIcon color="quinary" fontSize="large" ></LanguageIcon></SocialCard>
      </>
    )

  }
  return (
    <Box sx={{ flexGrow: 1 }} >
      <AppBar position="static"
        style={{
          backgroundColor:theme.palette.secondary.main
        }}
      >
        {mobile ?
          <>
            <Toolbar style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
              <MenuButtons></MenuButtons>
            </Toolbar>
            <Toolbar style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
              <SocialButtons></SocialButtons>
            </Toolbar>
          </>          
            :   
          <Toolbar style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <MenuButtons></MenuButtons>
            <SocialButtons></SocialButtons>
          </Toolbar>
          }
               
      </AppBar>
    </Box>
  );
}

export default Footer;